import { Box } from '@primer/react';
import { useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { useColors } from '../../hooks/useColors';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import Block from './Block';
const mainAction = actions.thongKe.cskh;
const ThongKeCSKHByMonth = () => {
    const { colors } = useColors();
    const { status, dataByMonth } = useSelector((x: RootState) => x.thongKe.cskh)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(mainAction.LOAD_BY_MONTH_START({
            nam_hoc,
            dm_coso_id
        }))

    }, [nam_hoc, dm_coso_id])


    // Chuẩn bị dữ liệu cho Bar Chart
    const dataSource = {
        labels: dataByMonth.map(item => item.name), // Nhãn các môn học
        datasets: [
            {
                label: '',

                data: dataByMonth.map(item => item.count), // Điểm tương ứng
                backgroundColor: dataByMonth.map((t, idx) => {
                    // return t.color;
                    return colors[idx % colors.length].hex;
                }),
                borderColor: dataByMonth.map((t, idx) => {
                    // return t.color;
                    return colors[idx % colors.length].hex;
                }),
                borderWidth: 2,
                barThickness: 20, // Độ dày của thanh Bar (pixel)
                maxBarThickness: 30, // Độ dày tối đa của mỗi Bar
                borderRadius: 4, // Bo tròn góc tha
                fill: true,
                tension: 0.4,
            },
        ],
    };
    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                display: false,
            },
            title: {
                display: true,
                text: '',
            },
            datalabels: {
                color: 'black',
                anchor: 'end',
                align: 'start',
                offset: -20,
                font: {
                    weight: 'bold',
                    size: 13,
                },
            },
        },
    };
    return (
        <>
            <Box sx={{ fontSize: 24, fontWeight: 600 }}>Chăm sóc khách hàng hàng tháng</Box>
            <Box sx={{ fontSize: "1rem", color: "fg.muted" }}>Biến động số lượng hỗ trợ qua các tháng</Box>
            <Box sx={{
                height: "400px",
                width: "100%",
                mt: 3
            }}>
                <Line data={dataSource} options={options} style={{

                }} />
            </Box>
        </>
    );
};

export default ThongKeCSKHByMonth;